import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Tab, TabsW } from './styled';
import { ProfileMobileTabsValues } from './types';

const TABS: { value: ProfileMobileTabsValues; labelKey: string }[] = [
  { value: ProfileMobileTabsValues.MY_PROFILE, labelKey: 'profile.mobileTabs.myProfile' },
  {
    value: ProfileMobileTabsValues.MY_PRIVATE_POSTS,
    labelKey: 'profile.mobileTabs.myPrivatePosts',
  },
  { value: ProfileMobileTabsValues.MY_EQUIPMENT, labelKey: 'profile.mobileTabs.myEquipment' },
  { value: ProfileMobileTabsValues.MY_TASKS, labelKey: 'profile.mobileTabs.myTasks' },
  { value: ProfileMobileTabsValues.MY_GOALS, labelKey: 'profile.mobileTabs.myGoals' },
];

type ProfileMobileTabsProps = {
  activeTab: ProfileMobileTabsValues;
  onChangeActiveTab: (tab: ProfileMobileTabsValues) => void;
};

export const ProfileMobileTabs = ({ activeTab, onChangeActiveTab }: ProfileMobileTabsProps) => {
  const { t } = useTranslation();
  const tabRefs = useRef<Partial<Record<ProfileMobileTabsValues, HTMLDivElement | null>>>({});

  useEffect(() => {
    tabRefs.current[activeTab]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [activeTab]);

  return (
    <TabsW>
      {TABS.map(({ value, labelKey }) => (
        <Tab
          key={value}
          ref={(el) => {
            tabRefs.current[value] = el;
          }}
          onClick={() => onChangeActiveTab(value)}
          className={activeTab === value ? 'active' : ''}
        >
          {t(labelKey)}
        </Tab>
      ))}
    </TabsW>
  );
};
